import React, { useState } from "react";
import BoxButton from "./BoxButton";
import "./Box.css";
import "./BoxEmployees.css";

const BoxEmployees = ({ employee, isSelected, onDelete, onUpdate }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({ ...employee });

  const handleInputChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleCancel = () => {
    setEditData({ ...employee });
    setIsEditing(false);
    setIsExpanded(false);
  };

  const handleSave = async () => {
  try {
    // Send updated employee to backend
    const res = await fetch(`https://security-backend-1nbc.onrender.com/api/employees/${editData.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(editData),
    });

    if (!res.ok) throw new Error("Failed to update employee");

    const updatedEmployee = await res.json();

    // Update parent state
    onUpdate(updatedEmployee);

    // Close edit mode
    setIsEditing(false);
    setIsExpanded(false);
  } catch (err) {
    console.error("Error saving employee:", err);
  }
};


  const startEdit = () => {
    setIsEditing(true);
    setIsExpanded(true);
  };

  return (
    <div
      className={`box-card employee-card ${isSelected ? "selected-employee" : ""}`}
    >
      {isEditing ? (
        <>
          <input
            type="text"
            value={editData.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
            placeholder="Name"
          />
          <input
            type="text"
            value={editData.job}
            onChange={(e) => handleInputChange("job", e.target.value)}
            placeholder="Job"
          />
          <input
            type="text"
            value={editData.location}
            onChange={(e) => handleInputChange("location", e.target.value)}
            placeholder="Location"
          />
          <input
            type="text"
            value={editData.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            placeholder="Email"
          />
          <input
            type="text"
            value={editData.phone}
            onChange={(e) => handleInputChange("phone", e.target.value)}
            placeholder="Phone"
          />
          <input
            type="text"
            value={editData.type}
            onChange={(e) => handleInputChange("type", e.target.value)}
            placeholder="Type"
          />
          <input
            type="text"
            value={editData.additional_information}
            onChange={(e) => handleInputChange("additional_information", e.target.value)}
            placeholder="Additional Info"
          />

          <div className="box-buttons">
            <BoxButton type="cancel" onClick={handleCancel} />
            <BoxButton type="save" onClick={handleSave} />
          </div>
        </>
      ) : (
        <>
          <h4>{employee.name}</h4>

          <div>
            <strong>Job:</strong> {employee.job || "N/A"}
          </div>
          <div>
            <strong>Location:</strong> {employee.location || "N/A"}
          </div>
          <div>
            <strong>Email:</strong> {employee.email || "N/A"}
          </div>
          <div>
            <strong>Phone:</strong> {employee.phone || "N/A"}
          </div>

          {isExpanded && (
            <>
              <div>
                <strong>Type:</strong> {employee.type || "N/A"}
              </div>
              <div>
                <strong>Additional Info:</strong>{" "}
                {employee.additional_information || "None"}
              </div>
            </>
          )}

          <div className="box-buttons">
            <BoxButton
              type="expand"
              expanded={isExpanded}
              onClick={() => setIsExpanded(!isExpanded)}
            />
            <BoxButton type="edit" onClick={startEdit} />
            <BoxButton
              type="delete"
              onClick={() => onDelete && onDelete(employee.id)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default BoxEmployees;


